module.exports = __webpack_public_path__ + "assets/img/explain.db429f5e.png";